import React from 'react'
import Navigation from './components/common/Navigation/Navigation'

const App = () => {
  return (
    <Navigation />
  )
}

export default App